export default function LeakerCard({ leaker }) {
  return (
    <div className="border border-gray-600 p-4 rounded shadow hover:shadow-md transition bg-gray-900">
      <h3 className="text-lg font-semibold text-green-400 font-mono">{leaker.name}</h3>
      <p className="text-sm text-gray-400 mb-1 font-mono">{leaker.role}</p>
      {leaker.note && <p className="text-sm text-green-300 italic font-mono">{leaker.note}</p>}
    </div>
  );
}